import { ArrowLeft, X } from "lucide-react";
import styles from "./ScriptPageHeader.module.scss";

interface ScriptBulkAttachHeaderProps {
  onBack: () => void;
  onClose: () => void;
}

export function ScriptBulkAttachHeader({
  onBack,
  onClose,
}: ScriptBulkAttachHeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.leftSection}>
        <button type="button" onClick={onBack} className={styles.closeButton}>
          <ArrowLeft size={18} />
        </button>
        <div className={styles.titleBlock}>
          <h3 className={styles.title}>Attach script</h3>
        </div>
      </div>
      <button type="button" onClick={onClose} className={styles.closeButton}>
        <X size={18} />
      </button>
    </header>
  );
}
